var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMimecast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24825_201154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00635 19.4685V4.50391H17.218C20.3879 4.50391 21.995 6.05639 21.995 9.11985V19.4893H17.9242V8.80863C18.0101 8.37413 17.6677 7.98112 17.218 7.89813H16.9602H14.0038V19.427H9.97602V7.91888H6.0771V19.4685H2.00635Z",
    fill: "#000066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24825_201154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(2 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMimecast);
export default __webpack_public_path__ + "static/media/Mimecast.0511ba6e332101e0a1773b91a09c07d1.svg";
export { ForwardRef as ReactComponent };